import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

interface IconBoxProps {
  item: {
    icon: string;
    titleKey: string;
    title: string;
    descriptionKey?: string;
    description?: string;
    url?: string;
  };
  size?: 'medium' | 'small';
  variant?: 'light' | 'default';
}
export const IconBox: ComponentType<IconBoxProps> = ({
  item,
  size = 'medium',
  variant = 'default',
}) => {
  const classes = useStyles({ size, variant });
  const { t } = useTranslation();
  return (
    <Box
      className={clsx(
        classes.root,
        { [classes.sizeSmall]: size === 'small' },
        { [classes.variantLight]: variant === 'light' }
      )}
    >
      <img src={item.icon} alt={item.title} className={classes.icon} />
      <Typography variant="h4" className={classes.title} color="text.primary">
        {t(item.titleKey, item.title)}
      </Typography>
      {size !== 'small' && item.description && item.descriptionKey && (
        <Typography variant="body2" mt={1}>
          {t(item.descriptionKey, item.description)}
        </Typography>
      )}
    </Box>
  );
};
